import LoaderIcon from '../../images/loader.svg';

export default function ContentLoader({ width, height }) {
    const widthValue = Number.isNaN(+width) ? width : width + 'px';
    const heightValue = Number.isNaN(+height) ? height : height + 'px';

    return (
        <div
            className={`content-loader`}
            style={{
                width: widthValue,
                height: heightValue,
            }}
        >
            <img src={LoaderIcon} className="rotate loader" alt="spinner"/>
        </div>
    );
}
